function median(values) {
  if (values.length === 0) return 0;

  values.sort((a, b) => a - b);
  const half = Math.floor(values.length / 2);

  if (values.length % 2) return values[half];

  return (values[half - 1] + values[half]) / 2.0;
}

function fraction(val, total) {
  if (val == null || !total) {
    return null;
  }
  return val / total;
}

function percent(val, total) {
  const f = fraction(val, total);
  return f != null ? f * 100 : null;
}

function sum(values, { valueSelector = (v) => v } = {}) {
  return (values || []).reduce((acc, current) => {
    const value = valueSelector(current);
    return acc + (value != null ? value : 0);
  }, 0);
}

function round(value, precision = 0, { method = Math.round } = {}) {
  const multiplier = 10 ** precision;
  return method(value * multiplier) / multiplier;
}

function average(arr, { valueSelector = (v) => v, precision } = {}) {
  if (!arr || !arr.length) { return null; }

  const values = arr.map(valueSelector).filter((v) => v !== null);

  if (!values.length) { return null; }

  const avg = sum(values) / values.length;
  return precision !== undefined ? round(avg, precision) : avg;
}

module.exports = {
  median,
  fraction,
  percent,
  sum,
  average,
  round,
};
